import { ObjectValues } from "@types";
const USER_AGENT = {
  android: "android",
  ios: "ios",
  web: "web",
} as const;

const { android, ios, web } = USER_AGENT;
export const platform: ObjectValues<typeof USER_AGENT> = navigator.userAgent.includes("becon_ios")
  ? ios
  : navigator.userAgent.includes("becon_android")
  ? android
  : web;
